<template>
  <div class="c-progress-bar">
    <div class="c-progress-bar-base"></div>
    <div class="c-progress-bar-loaded" :style="{ width: percentage + '%'}"></div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    current: number,
    max: number,
  }>();

  const percentage = computed(() => {
    return Math.min((props.current / props.max) * 100, 100);
  });
</script>

<style lang="scss">
  .c-progress-bar {
    position: relative;

    &-base {
      width: 100%;
      height: .5rem;
      background: $neutral-300;
      border-radius: $border-radius;
      position: absolute;
    }

    &-loaded {
      height: .5rem;
      background: $info;
      border-radius: $border-radius;
      position: absolute;
    }
  }
</style>